import i18n from 'modules/core/lib/i18n'

import { ContractSchedule } from 'modules/contracts/lib/contractSchedule'

export const getContractStatus = (contractSchedule: string) => {
  switch (contractSchedule) {
    case ContractSchedule.ongoing:
      return i18n.t('contract_versions.navigator.header.status.ongoing')
    case ContractSchedule.upcoming:
      return i18n.t('contract_versions.navigator.header.status.upcoming')
    default:
      return i18n.t('contract_versions.navigator.header.status.expired')
  }
}
